export default __webpack_public_path__ + "static/media/test_screen_layout.0ddf473f.png";